import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class NonAuthGuard  {
  /** Cannot access login/register page when user is logged in. */
  constructor(private auth: AuthService, private router: Router) {}

  canLoad(): boolean {
    return this.canAccessRoute();
  }

  canActivate(): boolean {
    return this.canAccessRoute();
  }
  canMatch(): boolean {
    return this.canAccessRoute();
  }

  private canAccessRoute(): boolean {
    if( this.auth.isLoggedIn){
      return false;
    }
    return true;
  }
}
